import React from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { fireErrorAnalytics } from '@atlassian/error-handling';

interface HubErrorBoundaryProps {
	children: React.ReactNode;
	fallback: React.ReactElement;
	packageName: string;
	id: string;
}

export const HubErrorBoundary = ({
	children,
	packageName,
	id,
	fallback,
}: HubErrorBoundaryProps) => {
	const onError = (error: Error) => {
		fireErrorAnalytics({
			error,
			meta: {
				id,
				packageName,
			},
		});
	};
	return (
		<ErrorBoundary onError={onError} fallback={fallback}>
			{children}
		</ErrorBoundary>
	);
};
